module.exports = __webpack_public_path__ + "img/xinjin4.7129b3da.png";